import {FormControl, TextField} from "@mui/material";

const getPlaceholderLabel = (label) => (label ? label.replace(/ \*$/, "") : "");

const MyTextField = ({value = "", editable, required, maxLength, minLength, onChange, label, ...props}) => {
    return (
        <FormControl fullWidth margin="dense">
            <TextField
                label={label}
                value={value}
                onChange={onChange}
                required={required}
                disabled={!editable}
                size="small"
                autoComplete={"new-password"}
                inputProps={{maxLength: maxLength, minLength: minLength, placeholder: `Enter ${getPlaceholderLabel(label)}`}}
                sx={{
                    '& input::placeholder': {color: 'rgba(0, 0, 0, 0.38)', opacity: 1},
                    ...(!editable && {
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: '#f5f5f5',
                            '& fieldset': {
                                borderColor: 'rgba(0, 0, 0, 0.23)',
                            },
                            '&.Mui-disabled': {
                                '& fieldset': {
                                    borderColor: 'rgba(0, 0, 0, 0.23)',
                                },
                            },
                        },
                        '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                            color: 'rgba(0, 0, 0, 0.87)',
                        },
                        '& .MuiInputLabel-root.Mui-disabled': {
                            color: 'rgba(0, 0, 0, 0.6)',
                        },
                    }),
                    ...props.sx,
                }}
                {...props}
            />
        </FormControl>
    );
};

export default MyTextField;
